import { render, staticRenderFns } from "./TrackEventsDetailView.vue?vue&type=template&id=64befb41"
import script from "./TrackEventsDetailView.vue?vue&type=script&lang=js"
export * from "./TrackEventsDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports